module.exports = __webpack_public_path__ + "static/Rectangle229-c57783f09122eb69d1d68545f862d5ba.png";